import IndexSearch from './IndexSearch';

export default IndexSearch;
